import { render, staticRenderFns } from "./BusinessObj.vue?vue&type=template&id=25a267c5&scoped=true&"
import script from "./BusinessObj.vue?vue&type=script&lang=js&"
export * from "./BusinessObj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a267c5",
  null
  
)

export default component.exports